/*
 * File: CustomerPOSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 10 Dec 2021 2:31:37 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCustomerPO } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const CustomerPOSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterCustomerPO(ev.target.value));
  }, 500);

  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="Customer PO" width={150} />
    </Space>
  );
};
